// extracted by mini-css-extract-plugin
module.exports = {"imageSize":"styles_imageSize__10_ln"};